import React from 'react'
import Avatar from '../atoms/Avatar'

interface Props {
  name?: string
  isPerson?: boolean
  image?: string | undefined
  position?: string | undefined
  company?: string | undefined
  className?: string
  size?: 'small' | 'medium' | 'big'
}

const Author: React.FC<Props> = ({
  name,
  image,
  position,
  company,
  className,
  size = 'small',
  isPerson = true,
}) => {
  const classes = {
    container: {
      small: '',
      medium: 'flex-col text-center',
      big: 'flex-col text-center',
    },
    name: {
      small: ' text-xs md:text-base -mb-2',
      big: 'text-xl md:text-2xl',
      medium: 'text-lg md:text-xl',
    },
    position: {
      small: ' text-xxs',
      medium: '',
      big: 'text-sm md:text-md ',
    },
  } as const

  return (
    <div
      className={`${classes.container[size]}  ${
        className || ''
      } flex items-center text-base justify-between author`}
    >
      <p
        className={` ${
          size === 'big' || size === 'medium' ? 'order-2' : 'order-1 w-3/4'
        }`}
      >
        {name ? (
          <span className={`${classes.name[size]} block `}>{name}</span>
        ) : null}
        {position ? (
          <span
            className={`leading-4 inline-block mt-3 ${classes.position[size]}`}
          >
            {position}
          </span>
        ) : null}
        {company ? (
          <span
            className={`leading-4 inline-block mt-3 ${classes.position[size]}`}
          >
            {company}
          </span>
        ) : null}
      </p>
      {image ? (
        <span
          className={`${
            size === 'big' || size === 'medium'
              ? 'order-1 w-30 h-30 my-2 md:my-4'
              : 'order-2 w-12 h-12 ml-4 w-1/4'
          } rounded-full inline-block text-right`}
        >
          <Avatar
            url={image}
            size={size === 'big' ? 'large' : 'normal'}
            rounded={isPerson}
            alt={name}
            className='inline-block'
          />
        </span>
      ) : null}
    </div>
  )
}

export default Author
